module.exports = __webpack_public_path__ + "static/media/icon-search-data.fd58a1db.svg";